import { formatDateCustom } from './helper';

const ISO_DATE_TIME_PATTERN = /^\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}/;
const EXPLICIT_TIME_ZONE_PATTERN = /(?:Z|[+-]\d{2}:?\d{2})$/i;

export const normalizeUtcTimestamp = (timestamp?: string | null): string => {
  const trimmed = (timestamp ?? '').trim();
  if (!trimmed) return '';

  const normalizedSeparator = trimmed.replace(/^(\d{4}-\d{2}-\d{2})\s+/, '$1T');
  const timestampWithZone =
    ISO_DATE_TIME_PATTERN.test(normalizedSeparator) &&
    !EXPLICIT_TIME_ZONE_PATTERN.test(normalizedSeparator)
      ? `${normalizedSeparator}Z`
      : normalizedSeparator;
  const parsed = new Date(timestampWithZone);

  return Number.isFinite(parsed.getTime()) ? parsed.toISOString() : '';
};

export const getUtcTimestampMs = (
  timestamp?: string | null,
  invalidValue = Number.MAX_SAFE_INTEGER
): number => {
  const parsed = new Date(normalizeUtcTimestamp(timestamp)).getTime();
  return Number.isFinite(parsed) ? parsed : invalidValue;
};

export const formatUtcTimestamp = (
  timestamp: string | null | undefined,
  format: string
): string => {
  const normalizedTimestamp = normalizeUtcTimestamp(timestamp);
  return normalizedTimestamp ? formatDateCustom(normalizedTimestamp, format) : '';
};
